import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import z from "zod";

import { requirePermissions } from "@/auth/shared";
import { db } from "@/db/connection";
import { publicProfileColumns } from "@/db/schema";

const getInvitesSchema = z.object({
  targetTournamentId: z.number(),
});

export const getInvitesFn = createServerFn({
  method: "GET",
})
  .middleware([requirePermissions({ tournaments: ["create"] })])
  .inputValidator(getInvitesSchema)
  .handler(async ({ data: { targetTournamentId } }) => {
    return db.query.tournamentInvites.findMany({
      where: {
        targetTournamentId,
      },
      with: {
        playerProfile: {
          columns: publicProfileColumns,
        },
        source: {
          columns: {
            id: true,
          },
          with: {
            sourceTournamentDivision: {
              columns: {
                id: true,
                name: true,
                gender: true,
                teamSize: true,
                displayGender: true,
                displayDivision: true,
              },
              with: {
                tournament: {
                  columns: {
                    id: true,
                    date: true,
                  },
                },
                division: {
                  columns: {
                    id: true,
                    name: true,
                    display: true,
                    maxAge: true,
                  },
                },
              },
            },
          },
        },
      },
    });
  });

export const getInvitesQueryOptions = (targetTournamentId: number) =>
  queryOptions({
    queryKey: ["invites", targetTournamentId],
    queryFn: () => getInvitesFn({ data: { targetTournamentId } }),
  });
